import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-surface" data-id="element-43">
      <div className="max-w-7xl mx-auto px-6" data-id="element-44">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-45">
          {/* Left Column: Map */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full h-[400px] lg:h-[500px] rounded-3xl overflow-hidden border border-border shadow-lg" data-id="element-46">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2540.485600297871!2d30.52125557685651!3d50.45068228729115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4ce50f8b6e3c3%3A0xb528dc4d6bfc05cb!2sKhreshchatyk%20St%2C%2015%2C%20Kyiv%2C%20Ukraine%2C%2002000!5e0!3m2!1sen!2sus!4v1716380000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Map" data-id="element-47"></iframe>
          </motion.div>

          {/* Right Column: Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-48">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-49">
              Потрібна консультація?
            </h2>
            <p className="text-secondary mb-12 text-lg leading-relaxed" data-id="element-50">
              Залиште свої контакти, оберіть напрямок, що вас цікавить, і ми
              зв'яжемося з вами протягом 15 хвилин для первинного розбору
              ситуації. Ви також можете зателефонувати нам або завітати до
              офісу.
            </p>

            <div className="space-y-8" data-id="element-51">
              <div className="flex items-start gap-5" data-id="element-52">
                <div className="w-12 h-12 rounded-2xl bg-background border border-border flex items-center justify-center text-primary flex-shrink-0" data-id="element-53">
                  <MapPin size={22} data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="font-medium text-primary mb-1" data-id="element-56">Наша адреса</h4>
                  <p className="text-secondary" data-id="element-57">
                    вул. Хрещатик, 15, Київ, Україна
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5" data-id="element-58">
                <div className="w-12 h-12 rounded-2xl bg-background border border-border flex items-center justify-center text-primary flex-shrink-0" data-id="element-59">
                  <Phone size={22} data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="font-medium text-primary mb-1" data-id="element-62">Телефон</h4>
                  <a href="tel:+380441234567" className="text-secondary hover:text-primary transition-colors" data-id="element-63">
                    +380 44 123 45 67
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5" data-id="element-64">
                <div className="w-12 h-12 rounded-2xl bg-background border border-border flex items-center justify-center text-primary flex-shrink-0" data-id="element-65">
                  <Mail size={22} data-id="element-66" />
                </div>
                <div data-id="element-67">
                  <h4 className="font-medium text-primary mb-1" data-id="element-68">
                    Електронна пошта
                  </h4>
                  <a href="mailto:info@lawyer.ua" className="text-secondary hover:text-primary transition-colors" data-id="element-69">
                    info@lawyer.ua
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-12" data-id="element-70">
              <a href="tel:+380441234567" className="inline-flex px-8 py-4 bg-primary text-background rounded-2xl font-medium hover:opacity-90 transition-opacity shadow-lg" data-id="element-71">
                Зателефонувати зараз
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}